export enum TimeTrackingDialogStep {
  TEASER,
  TRACKING_METHOD,
  TRACKING_ACCURACY,
  AUTO_APPROVE_HOURS,
  AUTO_APPROVE_SCHEDULE,
  CLOCKING_LOCATION,
}

export interface ChapterRadioButtonData {
  value: number | string;
  label: string;
  description: string;
}

export enum TimeTrackingMethod {
  SELF_CLOCKING = 'selfClocking',
  COPY_FROM_SCHEDULE = 'copyFromSchedule',
  MANUAL = 'manual',
}

export enum AutoApproveTimesheetHoursOption {
  YES,
  NO,
}
